'use client';
import { useQuery } from '@tanstack/react-query';

import { Auth } from '@air/api';

export const CURRENT_USER_INFO_KEY = 'CURRENT_USER';

export const getCurrentUserInfoKey = () => [CURRENT_USER_INFO_KEY];

export const useCurrentUserInfo = () => {
  return useQuery({
    queryFn: Auth.getCurrentUserInfo,
    queryKey: getCurrentUserInfoKey(),
    staleTime: 1000 * 60 * 60 * 24,
  });
};
